module.exports = __webpack_public_path__ + "img/cover5.bb6564ca.png";